module.exports = __webpack_public_path__ + "media/images/sold-out.en-754860e8ff63fa3f51add8af6d872d82.png";